import React from "react";
import TableText from "@/components/table/TableText";
import { numConvert, calculation, sum } from "@/method";
import _ from 'lodash'
import moment from 'moment'

const totalIndex = [0, 14, 22, 31];
const TOTALINDEX = [0, 14, 22, 31, 7, 21, 8, 29, 30, 38];
const inputIndex = [1, 2, 3, 4, 5, 6, 9, 10, 11, 13, 32, 33, 34, 35, 36, 37];
const percenIndex = [15, 16, 17, 18, 19, 20, 21];

export default (data, { date, data4_1_1, last }) => {
    // 累加mtd数据
    data.forEach((item, i) => {
        data[i].mtd = sum([
            _.get(last, `${i}.mtd`, 0),
            item.actual
        ]);
    });
    const totalNames = ['actual', 'mtd', 'budget', 'forecast', 'last'];
    // 计算合计数据
    totalNames.forEach(name => {
        data[7][name] = sum([
            data[1][name],
            data[2][name],
            data[3][name],
            data[4][name],
            data[5][name],
        ]);
        data[8][name] = sum([
            data[6][name],
            data[7][name],
        ]);

        data[12][name] = ~~(data[9][name] - data[10][name] - data[11][name]);

        data[15][name] = calculation(data[1][name], data[12][name], 4);
        data[16][name] = calculation(data[2][name], data[12][name], 4);
        data[17][name] = calculation(data[3][name], data[12][name], 4);
        data[18][name] = calculation(data[4][name], data[12][name], 4);
        data[19][name] = calculation(data[5][name], data[12][name], 4);
        data[20][name] = calculation(data[6][name], data[12][name], 4);
        data[21][name] = calculation(data[8][name], data[12][name], 4);
        data[23][name] = calculation(
            data[32][name],
            sum([data[1][name], data[6][name]])
        );
        data[24][name] = calculation(data[33][name], data[2][name]);
        data[25][name] = calculation(data[34][name], data[3][name]);
        data[26][name] = calculation(data[35][name], data[4][name]);
        console.log(data[32][name], sum([data[1][name]], data[6][name]));
        // 客房收入合计
        data[38][name] = sum([
            data[32][name],
            data[33][name],
            data[35][name],
            data[36][name],
            data[37][name],
            data[34][name],
        ]);
        data[29][name] = calculation(data[38][name], data[8][name]);
        data[30][name] = (numConvert(data[29][name]) * numConvert(data[21][name])).toFixed(2);

    });
    // 计算差异
    data.forEach((item, i) => {
        if ([15, 16, 17, 18, 19, 20, 21].includes(i)) {
            data[i].budgetDiff = (item.mtd - item.budget).toFixed(4);
            data[i].forecastDiff = (item.mtd - item.forecast).toFixed(4);
            data[i].lastDiff = (item.mtd - item.last).toFixed(4);
        } else {
            data[i].budgetDiff = calculation(item.mtd - item.budget, item.budget, 4);
            data[i].forecastDiff = calculation(item.mtd - item.forecast, item.forecast, 4);
            data[i].lastDiff = calculation(item.mtd - item.last, item.last, 4);
        }
    });
    console.log(data);
    return data
}

export const columns = (onChange, date, print) => {
    const isFirstDay = moment(date).format('D') == 1;
    return [
        {
            title: ``,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 250,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex: TOTALINDEX,
                };
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 9
                    },
                    children: <TableText data={props} />
                }
                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `当天Actual`,
            dataIndex: 'actual',
            key: 'actual',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['当天Actual'];
                const props = {
                    text,
                    index,
                    type: inputIndex.includes(index) && !print ? 'inputNumber' : percenIndex.includes(index) ? "percent" : 'number',
                    name: "actual",
                    onChange,
                    totalIndex: TOTALINDEX,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_3_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `当月MTD`,
            dataIndex: 'mtd',
            key: 'mtd',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['当月MTD'];
                const props = {
                    text,
                    index,
                    type: percenIndex.includes(index) ? "percent" : 'number',
                    name: "mtd",
                    onChange,
                    totalIndex: TOTALINDEX,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_3_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `当月Budget`,
            dataIndex: 'budget',
            key: 'budget',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['当月Budget'];
                const props = {
                    text,
                    index,
                    type: inputIndex.includes(index) && !print && isFirstDay ?
                        'inputNumber' :
                        percenIndex.includes(index) ? "percent" : 'number',
                    name: "budget",
                    onChange,
                    totalIndex: TOTALINDEX,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_3_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `差异`,
            dataIndex: 'budgetDiff',
            key: 'budgetDiff',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['差异'];
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "budgetDiff",
                    onChange,
                    totalIndex: TOTALINDEX,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_3_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `当月Forecast`,
            dataIndex: 'forecast',
            key: 'forecast',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['当月Forecast'];
                const props = {
                    text,
                    index,
                    type: inputIndex.includes(index) && !print && isFirstDay ? 'inputNumber' : percenIndex.includes(index) ? "percent" : 'number',
                    name: "forecast",
                    onChange,
                    totalIndex: TOTALINDEX,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_3_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `差异`,
            dataIndex: 'forecastDiff',
            key: 'forecastDiff',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['差异'];
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "forecastDiff",
                    onChange,
                    totalIndex: TOTALINDEX,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_3_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `去年当月 Actual`,
            dataIndex: 'last',
            key: 'last',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['去年当月 Actual'];
                const props = {
                    text,
                    index,
                    type: inputIndex.includes(index) && !print && isFirstDay ? 'inputNumber' : percenIndex.includes(index) ? "percent" : 'number',
                    name: "last",
                    onChange,
                    totalIndex: TOTALINDEX,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_3_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `差异`,
            dataIndex: 'lastDiff',
            key: 'lastDiff',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['差异'];
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "lastDiff",
                    onChange,
                    totalIndex: TOTALINDEX,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_3_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.3/compute.js